module.exports = __webpack_public_path__ + "static/img/mobile_home_cpjfw_qyjjfa.139d160.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_home_cpjfw_qyjjfa.png
// module id = MdT0
// module chunks = 21